import { ReactNode } from 'react';
import { Text, View } from '@react-pdf/renderer';

// Styles
import styles from '../style';

/** Reusable bullet row to eliminate the repeated View+Dot+Text pattern across sections */
const BulletRow = ({
  children,
  textStyle = styles.bulletText,
  allowWrap = false
}: {
  children: ReactNode;
  textStyle?: typeof styles.bulletText;
  allowWrap?: boolean;
}) => <View style={styles.listRow} wrap={allowWrap} data-sentry-element="View" data-sentry-component="BulletRow" data-sentry-source-file="BulletRow.tsx">
    <View style={styles.listDot} data-sentry-element="View" data-sentry-source-file="BulletRow.tsx" />
    <Text style={textStyle} data-sentry-element="Text" data-sentry-source-file="BulletRow.tsx">{children}</Text>
  </View>;
export default BulletRow;